import { Box } from '@chakra-ui/react';
import React, { ReactNode } from 'react';
interface IMainLayoutProps {
  children: ReactNode;
}
const MainLayout: React.FC<IMainLayoutProps> = ({ children }) => {

  return (
   <Box>MainLayout</Box>
  );
};

export default MainLayout;
